(function ($) {
	$(document).ready(function () {
		window.profetEmailSignup = {
			variables: {
				wrapperElement: $('.email-signup-wrapper'),
				formElement: $('#email-signup'),
				messageContainerElement: $('.email-signup-wrapper').find('.message-container'),
				timeBeforeAppear: 15000,
				fields: [$('#email-signup').find('input[name="email"]'), $('#email-signup').find('select[name="user_group"]')],
			},
			init: function () {
				$('.close-email-signup').on('click', function (event) {
					event.preventDefault();
					profetEmailSignup.variables.wrapperElement.removeClass('visible');
					profet.setCookie('email-signup', 'closed', 30);
				});
				if (!profet.getCookie('email-signup') && !profetEmailSignup.isFacebookApp()) {
					profetEmailSignup.setupFormAppear();
				}
				profetEmailSignup.handleInputChange();
				profetEmailSignup.handleSubmit();
			},
			handleInputChange: function () {
				for (var i in profetEmailSignup.variables.fields) {
					var field = profetEmailSignup.variables.fields[i];
					field.on('change', function () {
						profetEmailSignup.variables.messageContainerElement.html('');
					});
					field.on('keydown', function () {
						profetEmailSignup.variables.messageContainerElement.html('');
					});
				}
				$('select[name="user_group"]').on('change', function () {
					if ($(this).val() == 'Annat') {
						$('.target-audience-other-wrapper').show();
					} else {
						$('.target-audience-other-wrapper').hide();
						$('input[name="user_group_other"]').val('');
					}
				});
			},
			setupFormAppear: function () {
				window.setTimeout(function () {
					profetEmailSignup.variables.wrapperElement.addClass('visible');
				}, profetEmailSignup.variables.timeBeforeAppear);
			},
			validateFields: function () {
				var emailValue = $('#email-signup').find('input[name="email"]').val();
				if (!profetEmailSignup.emailCheck(emailValue)) {
					profetEmailSignup.variables.messageContainerElement.html('Dubbelkolla att din mejladress är korrekt ifylld.');
					return false;
				}

				for (var i in profetEmailSignup.variables.fields) {
					var field = profetEmailSignup.variables.fields[i];
					if (field.val() === '' || !field.val() || !$('#email-signup').find('#gdpr').is(':checked')) {
						profetEmailSignup.variables.messageContainerElement.html('Du måste fylla i alla fält och godkänna personuppgiftspolicyn.');
						return false;
					}
				}
				return true;
			},
			isFacebookApp: function () {
				var ua = navigator.userAgent || navigator.vendor || window.opera;
				return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
			},
			emailCheck: function (str) {
				var ret = true;
				var at = '@';
				var dot = '.';
				var lat = str.indexOf(at);
				var lstr = str.length;
				var ldot = str.indexOf(dot);
				if (str.indexOf(at) == -1) {
					ret = false;
				}
				if (str.indexOf(at) == -1 || str.indexOf(at) == 0 || str.indexOf(at) == lstr) {
					ret = false;
				}
				if (str.indexOf(dot) == -1 || str.indexOf(dot) == 0 || str.indexOf(dot) == lstr) {
					ret = false;
				}
				if (str.indexOf(at, lat + 1) != -1) {
					ret = false;
				}
				if (str.substring(lat - 1, lat) == dot || str.substring(lat + 1, lat + 2) == dot) {
					ret = false;
				}
				if (str.indexOf(dot, lat + 2) == -1) {
					ret = false;
				}
				if (str.indexOf(' ') != -1) {
					ret = false;
				}
				return ret;
			},
			handleSubmit: function () {
				profetEmailSignup.variables.formElement.on('submit', function (event) {
					event.preventDefault();
					$('#email-signup').find('button[type="submit"]').attr('disabled', true);

					profetEmailSignup.variables.messageContainerElement.html('');

					if (!profetEmailSignup.validateFields()) {
						$('#email-signup').find('button[type="submit"]').attr('disabled', false);
						return;
					}

					/*
					$.ajax({
						method: 'POST',
						url: '/wp-json/profet/email/sendEmailSignupEmail',
						data: {
							email: $('#email-signup')
								.find('input[name="email"]')
								.val(),
							user_group: $('#email-signup')
								.find('select[name="user_group"]')
								.val(),
							gdpr: $('#email-signup')
								.find('input[name="gdpr"]')
								.val(),
							name: $('#email-signup')
								.find('input[name="name"]')
								.val(),
							user_group_other: $('input[name="user_group_other"]').val()
						},
						success: function(data) {
							profetEmailSignup.variables.messageContainerElement.html(data.data.message);
							profetEmailSignup.variables.formElement.find('button').hide();
							profet.setCookie('email-signup', 'closed', 30);
						},
						error: function(error) {
							profetEmailSignup.variables.messageContainerElement.html(error.responseJSON.data.message);
							$('#email-signup')
								.find('button[type="submit"]')
								.attr('disabled', false);
						}
                    });
                    */

					/* Send second Ajax request to the API for email software Paloma to add the contact there too */
					$.ajax({
						method: 'GET',
						url: 'https://newsletter.paloma.se//register/',
						data: {
							gora: 'pren',
							distlistkey: '182355',
							email: $('#email-signup').find('input[name="email"]').val(),
							namn: $('#email-signup').find('input[name="name"]').val(),
							userfield_malgrupp: $('#email-signup').find('select[name="user_group"]').val(),
						},
						success: function (data) {
							profetEmailSignup.variables.messageContainerElement.html('Tack för din anmälan!');
							profetEmailSignup.variables.formElement.find('button').hide();
							profet.setCookie('email-signup', 'closed', 30);
						},
						error: function (error) {
							profetEmailSignup.variables.messageContainerElement.html();
							$('#email-signup').find('button[type="submit"]').attr('disabled', false);
						},
					});

					/* Track form submission in Google Analytics */
					__gaTracker('send', 'event', {
						eventCategory: 'Email signup',
						eventAction: 'click',
						eventLabel: 'Email signup',
						transport: 'beacon',
					});

					return false;
				});
			},
		};
		profetEmailSignup.init();
	});
})(jQuery);
